import type { LeaseActionProps } from '../../../models/Types';
import { ZILLOW_LEASES_HELP } from '../../../constants/stringConstants';

export default function OpenTabHelpLink({ terminateActiveAction }: LeaseActionProps) {
  window.open(ZILLOW_LEASES_HELP, '_blank');
  terminateActiveAction();
  return null;
}
